import { render, staticRenderFns } from "./item.vue?vue&type=template&id=d8e0720a&scoped=true"
import script from "./item.vue?vue&type=script&lang=ts"
export * from "./item.vue?vue&type=script&lang=ts"
import style0 from "./item.vue?vue&type=style&index=0&id=d8e0720a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e0720a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonCustomImage: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/common/custom-image.vue').default})
